import React, { useRef } from 'react';
import styled from 'styled-components';
import { MAX_BIN_COUNT } from '../utils';
import BucketContextualMenu from './BinContextualMenu';
import BucketRenameEditor from './BucketRenameEditor';
import { MenuActions } from '../types';

interface IProps {
  bucketRowActionsHandler: (action: MenuActions, index: number) => void;
  onNameChangeHandler: (newName: string, index: number) => void;
  rowIndex: number;
  isOpenEditWindow: boolean;
  bucketsLength: number;
  customName?: string;
}

const Container = styled.div`
  text-align: center;
`;

export default ({
  bucketRowActionsHandler,
  onNameChangeHandler,
  rowIndex,
  isOpenEditWindow,
  bucketsLength,
  customName,
}: IProps) => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <Container ref={ref}>
      <BucketContextualMenu
        showAddBin={bucketsLength < MAX_BIN_COUNT}
        showRenameBin={true}
        showRemoveBin={bucketsLength > 1}
        onClick={(action) => bucketRowActionsHandler(action, rowIndex)}
        rowIndex={rowIndex}
      />
      {isOpenEditWindow && (
        <BucketRenameEditor
          anchorRef={ref}
          open
          defaultName={customName}
          onChange={(newName: string) => onNameChangeHandler(newName, rowIndex)}
          onClose={() => bucketRowActionsHandler(MenuActions.Edit, -1)}
        />
      )}
    </Container>
  );
};
